import { render } from "./Manifesto.vue?vue&type=template&id=27cf529c&scoped=true"
import script from "./Manifesto.vue?vue&type=script&lang=js"
export * from "./Manifesto.vue?vue&type=script&lang=js"

import "./Manifesto.vue?vue&type=style&index=0&id=27cf529c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cf529c"]])

export default __exports__